export default __webpack_public_path__ + "static/alexandre-debieve-FO7JIlwjOtU-unsplash-96daf357b79a37079b622a9c7e3f5d5b.jpg";